import { Box } from '@mui/material';
import theme from '@shared/themes/darkTheme';
import { MIGRATION_BANNER_HEIGHT } from './MigrationBanner';

export const DemoLabel = ({
  isDemoLabelVisible,
  setIsDemoLabelVisible,
}: {
  isDemoLabelVisible: boolean;
  setIsDemoLabelVisible: (isDemoLabelVisible: boolean) => void;
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: MIGRATION_BANNER_HEIGHT,
        right: 8,
        backgroundColor: theme.palette.background.uatBanner,
        color: 'white',
        padding: '2px 8px',
        borderRadius: '0 0 6px 6px',
        fontSize: '10px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        zIndex: theme.zIndex.appBar + 10,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderTop: 'none',
        transition: 'opacity 0.3s ease-in-out',
        cursor: 'pointer',
        opacity: isDemoLabelVisible ? 1 : 0,
        pointerEvents: isDemoLabelVisible ? 'auto' : 'none',
      }}
      onMouseEnter={() => {
        setIsDemoLabelVisible(false);
      }}
      onMouseLeave={() => {
        setTimeout(() => setIsDemoLabelVisible(true), 2000);
      }}
    >
      DEMO
    </Box>
  );
};
